import { useTheme } from '@mui/material';
import React from 'react';

const PageErrorTheme: React.FC = (props: any) => {
	const {
		palette: {
			illustrationAccent,
			primary: { dark: primaryDark }
		}
	} = useTheme();

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="300"
			height="300"
			fill="none"
			{...props}
		>
			<path
				d="M113.716 261.163c27.237-3.327 46.618-28.105 43.291-55.34s-28.104-46.618-55.341-43.291-46.618 28.104-43.29 55.341 28.104 46.618 55.34 43.29z"
				fill={illustrationAccent}
			/>
			<g fill={illustrationAccent}>
				<path d="M86.536 141.833l-23.82 20.276-2.864-4.963 26.684-15.313z" />
			</g>
			<g stroke={primaryDark}>
				<g>
					<path d="M185.026 237.001a2.75 2.75 0 1 0 0-5.501 2.75 2.75 0 1 0 0 5.501z" />
					<path d="M157.175 207.396l59.777-34.682-61.536-106.085-84.193 48.832-11.371 41.685 11.825 20.446m-.454-62.13l15.313 26.372-26.684 15.313" />
					<path d="M86.536 141.833l-23.82 20.276-2.864-4.962 26.684-15.314z" />
				</g>
				<g>
					<path d="M110.046 104.997l3.942-31.363" />
				</g>
				<g>
					<path d="M168.323 200.959l58.955 13.781 23.083-98.741-76.707-17.922" />
					<path d="M201.331 113.391l20.134-16.646" />
				</g>
				<g>
					<path d="M107.69 261.53c27.439 0 49.682-22.244 49.682-49.682s-22.243-49.682-49.682-49.682-49.682 22.242-49.682 49.682 22.243 49.682 49.682 49.682z" />
					<g>
						<path d="M114.269 187.205l-13.158 49.286" />
						<path d="M132.343 218.427l-49.285-13.158m86.119-166.798l10.322 17.78" />
						<path d="M183.21 42.186l-17.78 10.35M31.327 156.41l-23.111-5.275m31.199 31.845L23.28 200.363m239.134-31.476l17.213 16.362m-10.584-43.331l22.743-6.721" />
					</g>
				</g>
			</g>
			<defs>
				<path d="M114.47 73.634c3.023 0 5.473-2.45 5.473-5.473s-2.45-5.473-5.473-5.473-5.473 2.45-5.473 5.473 2.45 5.473 5.473 5.473z" />
				<path d="M224.862 98.275a4.54 4.54 0 0 0 4.538-4.537 4.54 4.54 0 0 0-4.538-4.537 4.54 4.54 0 0 0-4.537 4.537 4.54 4.54 0 0 0 4.537 4.537z" />
			</defs>
		</svg>
	);
};

export default PageErrorTheme;
